import * as LucideIcons from 'lucide-react';
import type { ComponentType } from 'react';

// Apps send icon names in lucide-react's kebab-case form (e.g. "book-open"),
// matching the public lucide.dev catalog. The npm package exports them in
// PascalCase, so we translate here. A small alias map lets the host accept a
// handful of domain icons that lucide doesn't ship — those map to the nearest
// lucide glyph.
const ICON_ALIASES: Record<string, string> = {
  'pepper-shaker': 'ChefHat',
};

function kebabToPascal(name: string): string {
  return name
    .split('-')
    .map((part) => (part ? part.charAt(0).toUpperCase() + part.slice(1) : ''))
    .join('');
}

type IconComponent = ComponentType<{ className?: string; 'aria-hidden'?: boolean }>;

/**
 * Resolve an app-supplied icon string to a renderable component. Returns null
 * when the name is unknown — callers should render no glyph in that case,
 * matching the contract's "icon is optional, fallback may be no glyph" guidance.
 */
export function resolveAppNavIcon(name: string | undefined | null): IconComponent | null {
  if (!name || typeof name !== 'string') return null;
  const lookup = (ICON_ALIASES[name] || kebabToPascal(name)) as string;
  const Icon = (LucideIcons as Record<string, unknown>)[lookup] as IconComponent | undefined;
  return Icon ?? null;
}
